import React from 'react';
import $ from 'jquery';
import AdRuleRedux from '../../../containers/pluginSettings/AdRules/AdRule';
import { AR_DESCRIPTION } from '../../../constants/Labels';
import { updateSize } from '../../../helpers/tools';

class AdRules extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    updateSize();
    $('#csar').css('visibility', $('#ssar').is(':checked') ? 'hidden' : 'visible');
  }
  selectSsar = () => {
    let active = $('#ssar').is(':checked') ? true : false;
    $('#csar').css('visibility', active ? 'hidden' : 'visible');
    this.props.setSsar(active);
  };

  render() {
    return (
      <div className="pluginSettingsSection">
        <div
          className="settingsDescription description"
          dangerouslySetInnerHTML={{ __html: AR_DESCRIPTION }}
        ></div>
        <div className="settingsInputs">
          <div>
            <h3>Server side </h3>
            <div>
              <label htmlFor="ssar">Enable ad rules server side</label>{' '}
              <input
                type="checkbox"
                id="ssar"
                defaultChecked={this.props.ssar}
                onChange={() => this.selectSsar()}
              />
            </div>
          </div>
        </div>
        <div className="settingsInputs" id="csar">
          <div className="divider"></div>
          {this.props.adRules.map((item, index) => (
            <AdRuleRedux index={index} key={index} />
          ))}
          <button
            type="button"
            id="add-new-ad-rule"
            className="btnGeneral"
            onClick={() => this.props.addNewAdRuleAction()}
          >
            Add new
          </button>
        </div>
      </div>
    );
  }
}

export default AdRules;
